// Sorts an array of objects based on a given list of orders, based on https://gist.github.com/ecarter/1423674
export function sortByOrderList<T, K extends keyof T>(
  key: K,
  orderList: Array<T[K]>
) {
  return (a: T, b: T) => {
    const lhs = a[key],
      rhs = b[key];
    return orderList.indexOf(lhs) - orderList.indexOf(rhs);
  };
}
